import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import moment from 'moment';

import { ExtendedRawConsumptionProperties } from '@store';
import { HemsProperties, ViError } from '@vi-iot/client';

import { FilterType } from '../../+installations/installation/energy-historical-data-modal/energy-filters-header/energy-filters.data';

import { HemsFlowType } from './energy-historical-data.helpers';
import {
  HemsHistoricalData,
  LegendFeature,
  SavedSelectedFeature,
} from './energy-historical-data.model';

import Moment = moment.Moment;

export namespace EnergyHistoricalDataActions {
  export enum Type {
    LOAD_CHART_DATA = '[ENERGY HISTORICAL DATA] Load Chart Data',
    LOAD_CHART_DATA_SUCCESS = '[ENERGY HISTORICAL DATA] Load Chart Data Success',
    LOAD_CHART_DATA_ERROR = '[ENERGY HISTORICAL DATA] Load Chart Data Error',
    ADD_LEGEND_FEATURE = '[ENERGY HISTORICAL DATA] Add Legend Feature',
    CLEAR_LEGEND_FEATURES = '[ENERGY HISTORICAL DATA] Clear Legend Features',
    UPDATE_FILTERS = '[ENERGY HISTORICAL DATA] Update Filters',
    UPDATE_SELECTED_FEATURES = '[ENERGY HISTORICAL DATA] Update Selected Features',
    RESET_SELECTED_FEATURES = '[ENERGY HISTORICAL DATA] Reset Selected Features',
    RESET_STORE = '[ENERGY HISTORICAL DATA] Reset Store',
    LOAD_LEGACY_HP_CHART_DATA = '[ENERGY HISTORICAL DATA] Load Legacy HP Chart Data',
    LOAD_LEGACY_HP_CHART_DATA_SUCCESS = '[ENERGY HISTORICAL DATA] Load Legacy HP Chart Data Success',
    LOAD_LEGACY_HP_CHART_DATA_ERROR = '[ENERGY HISTORICAL DATA] Load Legacy HP Chart Data Error',
    SAVE_SELECTED_FEATURE_TO_STORAGE = '[ENERGY HISTORICAL DATA] Save Selected Feature To Storage',
    UPDATE_SELECTED_FEATURES_FROM_STORAGE = '[ENERGY HISTORICAL DATA] Updated Selected Features From Storage',
    LOAD_SELECTED_FEATURES_FROM_STORAGE = '[ENERGY HISTORICAL DATA] Load Selected Features From Storage',
  }

  export const loadChartData = createAction(Type.LOAD_CHART_DATA);
  export const setHemsAnalysisTab = createAction(
    '[ENERGY HISTORICAL DATA] Set Hems Analysis Tab',
    props<{ hemsAnalysisTab: HemsFlowType }>()
  );

  export const addLegendFeature = createAction(
    Type.ADD_LEGEND_FEATURE,
    props<{
      feature: LegendFeature;
    }>()
  );

  export const clearLegendFeatures = createAction(Type.CLEAR_LEGEND_FEATURES);

  export const loadChartDataSuccess = createAction(
    Type.LOAD_CHART_DATA_SUCCESS,
    props<{
      chartData: HemsHistoricalData;
    }>()
  );

  export const loadChartDataError = createAction(
    Type.LOAD_CHART_DATA_ERROR,
    props<{
      error: ViError;
    }>()
  );

  export const updateFilters = createAction(
    Type.UPDATE_FILTERS,
    props<{
      filterType: FilterType;
      date: Moment;
    }>()
  );

  export const updateSelectedFeatures = createAction(
    Type.UPDATE_SELECTED_FEATURES,
    props<{
      selectedFeatures: HemsProperties[];
    }>()
  );

  export const resetStore = createAction(Type.RESET_STORE);

  export const resetSelectedFeatures = createAction(Type.RESET_SELECTED_FEATURES);

  export const loadLegacyHPChartData = createAction(
    Type.LOAD_LEGACY_HP_CHART_DATA,
    props<{
      gatewaySerial: string;
      fetchOnlyDayValues: boolean;
      feature: HemsProperties;
    }>()
  );

  export const loadLegacyHPChartDataSuccess = createAction(
    Type.LOAD_LEGACY_HP_CHART_DATA_SUCCESS,
    props<{
      legacyChartData: ExtendedRawConsumptionProperties[];
    }>()
  );

  export const loadLegacyHPChartDataError = createAction(Type.LOAD_LEGACY_HP_CHART_DATA_ERROR);

  export const loadSelectedFeatureFromStorage = createActionGroup({
    source: Type.LOAD_SELECTED_FEATURES_FROM_STORAGE,
    events: {
      attempt: emptyProps(),
      success: props<{ savedSelectedFeature: SavedSelectedFeature }>(),
      error: props<{ error: any }>(),
    },
  });

  export const saveSelectedFeatureToStorage = createAction(
    Type.SAVE_SELECTED_FEATURE_TO_STORAGE,
    props<{
      savedSelectedFeatures: HemsProperties[];
      installationId: string;
      isThermalFlow: boolean;
    }>()
  );
}
